import { toWhatsAppShareLink } from "@/lib/whatsapp-link";

export const BLOG_SHARE_UI = {
  label: "مشاركة المقال مع أمّ قد تحتاجه",
  native: "مشاركة",
  whatsapp: "واتساب",
  facebook: "فيسبوك",
  telegram: "تيليغرام",
  x: "X",
  copy: "نسخ الرابط",
  copied: "تم نسخ الرابط",
} as const;

/** Takes only the public post title and canonical URL — never reader data. */
export function blogShareMessage(title: string, url: string): string {
  return `مقال من د. سارة النحّاس: ${title} ${url}`;
}

export function blogShareLinks(title: string, url: string) {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  return {
    whatsapp: toWhatsAppShareLink(blogShareMessage(title, url)),
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    telegram: `https://t.me/share/url?url=${u}&text=${t}`,
    x: `https://x.com/intent/tweet?text=${t}&url=${u}`,
  };
}
